import logoSvg from '../assets/logo.svg?source';

function Logo() {
  return (
    <div
      className="logo"
      role="img"
      aria-label="RedHare Market"
      dangerouslySetInnerHTML={{ __html: logoSvg }}
    />
  );
}

export default Logo;
